module.exports = __webpack_public_path__ + "img/icon_context_person_on.4f0232f.svg";